module.exports = __webpack_public_path__ + "static/img/planet4.06e570a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planet4.png
// module id = yDJY
// module chunks = 1